import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import moment from 'moment';
import { Table, Tag, Card, message, Button, Layout, Badge } from 'antd';
import { Field } from 'kts-scaffold-framework/utils/doc';
import { authManage } from '../../../api';
import MyStore from 'kts-platform-frame/redux/MyStore';
import CustPage2 from './CustPage2';
import { history } from 'kts-platform-frame/routes';
import getCompanyInfoList from '../../../api/systemManage/role/getCompanyInfoList';
import JSString from 'kts-scaffold-framework/utils/kit/JSString';
import InfiniteScroll from 'kts-scaffold-framework/component/InfiniteScroll';
const { Header, Content, Footer } = Layout;
const css = require('./index.scss');
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class AuthRecord extends UIBasic<IProps, ModulesState, any> {
    public scroller: InfiniteScroll;
    private columns = [
        {
            title: '序号',
            dataIndex: 'index',
            width: 50,
            render: (text, record, index) => {
                return <div>{index + 1}</div>;
            }
        },
        {
            title: '销方名称',
            dataIndex: 'supplierName',
            key: 'supplierName',
            width: 200,
            render: (text, record) => {
                return (
                    <div>
                        {text}
                    </div>
                );
            }
        },
        {
            title: '发票代码',
            dataIndex: 'invoiceCode',
            key: 'invoiceCode',
            width: 130,
            render: (text, record) => {
                return (
                    <div>
                        {text}
                    </div>
                );
            }
        },
        {
            title: '发票号码',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            width: 120,
            className: 'text-center',
            render: (text, record) => {
                return (
                    <div>
                        {text}
                    </div>
                );
            }
        },
        {
            title: '开票日期',
            dataIndex: 'invoiceDate',
            className: 'text-center ant-td-status',
            width: 110,
            render: (text, record) => moment(text).format('YYYY-MM-DD')
        },
        {
            title: '金额',
            dataIndex: 'amountWithoutTax',
            className: 'text-center',
            width: 140,
            render: (text, record) => {
                return <span> {'¥' + Field.formatMoney(text, 2)} </span>;
            }
        },
        {
            title: '税额',
            dataIndex: 'amountTax',
            className: 'text-center',
            width: 140,
            render: (text, record) => {
                return <span>{'¥' + Field.formatMoney(text, 2)}</span>;
            }
        },
        {
            title: '认证结果',
            dataIndex: 'authState',
            width: 200,
            className: 'text-left',
            render: (text, record) => {
                return (
                    <div>
                        {text === 'UNCHECK' && (
                            <Badge status="default" text='未认证' />
                        )}
                        {text === 'CHECKING' && (
                            <Badge status="processing" text='认证中' />
                        )}
                        {text === 'FAILED' && (
                            <Badge status="error" text={`失败: ${record.authResponse}`} />
                        )}
                        {text === 'PASS' && (
                            // <Tag color="green">认证成功</Tag>
                            <Badge status="success" text='认证成功' />
                        )}
                    </div>
                );
            }
        }
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            data: [],
            pageSize: 20,
            total: 0,
            pageNum: 0,
            passState: this.props.location.state,
            countData: null,
            query: JSString.queryStringParse(this.props.location.search),
            company: null,
            hasMore: true,
            loading: false,
        };
    }
    componentDidMount() {
        // this.getDataList();
        this.initScrollloading();
        this.getData();
        this.getLogCount();
        this.getCompanyInfo();
    }
    /** 初始化加载 */
    initScrollloading = () => {
        let { p2 } = this.modulesState.record;
        p2.confirmLoading = false;
        p2.confirmHasMore = true;
        ModulesAction.setModulesState();
    }
    getCompanyInfo = () => {
        const companyId = MyStore.instance.getState().user.currentcompanyId;
        getCompanyInfoList(this, { companyId }).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.setState({
                        company: res
                    });
                }
            }
        });
    }
    getDataList = (page: number = 1) => {
        const { query } = this.state;
        authManage.authRecordDetail(this,
            {
                pageNum: page,
                pageSize: this.state.pageSize,
                companyId: MyStore.instance.getState().user.currentcompanyId,
                invoicePeriod: query.invoicePeriod,
                authBatchId: query.authBatchId
            }
        ).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.setState({
                        data: res.items,
                        pageNum: page,
                        total: res.pageMeta.total
                    });
                }
            }
        });
    }
    getLogCount = () => {
        let companyId = MyStore.instance.getState().user.currentcompanyId;
        authManage.authRecordLog(this,
            {
                companyId: companyId
            }
        ).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.setState({
                        countData: res
                    });
                }
            }
        });
    }
    mapListToPage = (page) => {
        this.getDataList(page);
    }
    onSizeChange = (current, pageSize) => {
        this.setState({
            pageSize: pageSize
        }, () => this.getDataList(current));
    }
    render() {
        const { data, company, countData, query, loading, hasMore } = this.state;
        let { p2 } = this.modulesState.record;
        let statics = { money: 0, tax: 0 };
        const _datasource = data && data.map(function (item: any, index: any) {
            statics.money += item.amountWithoutTax;
            statics.tax += item.amountTax;
            return {
                ...item,
                index
            };
        });
        return (
            <Card
                title={<span>企业认证结果清单</span>}
                extra={<div><Button type="default" onClick={() => { history.goBack(); }} className="ml-10 defaultbtn">返回</Button></div>}
            >
                <div style={{ height: 'calc(100% - 170px)' }}>
                    <div className={`${css.bgback} ${css.paddingheader}`} style={{overflow:"hidden"}}>
                        <div className={`${css['item']} ${css.width50pl}`}>
                            <span className={css['label']}>企业名称</span>
                            <span>{company && company.name}</span>
                        </div>
                        <div className={`${css['item']} ${css.width50pl}`}>
                            <span className={css['label']}>认证税期</span>
                            <span>{this.state.passState && this.state.passState.invoicePeriod ? this.state.passState.invoicePeriod : ''}</span>
                        </div>
                        <div className={`${css['item']} ${css.width50pl}`}>
                            <span className={css['label']}>纳税人识别号</span>
                            <span>{company && company.taxId}</span>
                        </div>
                        <div className={`${css['item']} ${css.width50pl}`}>
                            <span className={css['label']}>认证时间</span>
                            <span>{this.state.passState && this.state.passState.authTime}</span>
                        </div>
                        <div className={`${css['item']} ${css.width50pl}`}>
                            <span className={css['label']}>备注信息</span>
                            <span>{this.state.passState && this.state.passState.batchNote}</span>
                        </div>
                        <div className={`${css['item']} ${css.width50pl}`}>
                            <span className={css['label']}>认证类型</span>
                            <span>{this.state.passState && this.state.passState.authType === 2 ? '退税认证' : '抵扣认证'}</span>
                        </div>
                    </div>
                    <Layout>
                        <Content className={`${css.bgback}`}>
                            <div style={{ height: 'calc(100vh - 270px)', overflow: 'auto' }}>
                                <InfiniteScroll
                                    loadMore={this.getData}
                                    hasMore={!loading && hasMore}
                                    ref={(target) => { this.scroller = target; }}
                                >
                                    <Table
                                        columns={this.columns}
                                        dataSource={_datasource}
                                        className={css.bgback}
                                        pagination={false}
                                        rowKey="index"
                                        scroll={{ y: 'calc(100vh - 325px)' }}
                                    />
                                </InfiniteScroll>
                            </div>
                        </Content>
                    </Layout>
                    <Footer className={css.companySettleFooter}>
                        {
                            data &&
                            <div>
                                <div className="pull-left">
                                    <span className={css.heji}>合计: </span>
                                    {/* <CustPage2 pageSize={this.state.pageSize} count={countData} data={data.pageMeta} onChange={this.mapListToPage} onShowSizeChange={this.onSizeChange} /> */}
                                </div>
                                <div className="pull-right">
                                    <span>金额:  <span style={{ 'fontWeight': 'bolder' }}>¥{Field.formatMoney(statics && statics.money, 2)}</span></span>
                                    <span style={{ 'padding': '0 8px' }}>|</span>
                                    <span>税额:  <span style={{ 'fontWeight': 'bolder' }}>¥{Field.formatMoney(statics && statics.tax, 2)}</span></span>
                                    <span style={{ 'padding': '0 8px' }}>|</span>
                                    <span>发票数:  <span style={{ 'fontWeight': 'bolder' }}>{this.state.total}</span></span>
                                </div>
                            </div>
                        }
                    </Footer>
                </div>
            </Card>
        );
    }
    getData = () => {
        let { p2 } = this.modulesState.record;
        let { loading, hasMore } = this.state;
        console.log(p2.confirmHasMore);
        this.setState({
            loading: true
        });
        if (hasMore) {
            //p2.confirmLoading = true;
            //ModulesAction.setModulesState();
            const { query } = this.state;
            authManage.authRecordDetail(this,
                {
                    pageNum: this.state.pageNum + 1,
                    pageSize: this.state.pageSize,
                    companyId: MyStore.instance.getState().user.currentcompanyId,
                    invoicePeriod: query.invoicePeriod,
                    authBatchId: query.authBatchId
                }
            ).then((response: any) => {
                const err = response.err;
                const res = response.res;
                if (err) {
                    message.error(err.status.description);
                    return null;
                } else {
                    if (res) {
                        // p2.confirmHasMore = res.pageMeta.total > res.pageMeta.pageNum * res.pageMeta.pageSize;
                        // p2.confirmLoading = false;
                        // ModulesAction.setModulesState();
                        console.log(p2.confirmHasMore, p2.confirmLoading);
                        if (res.pageMeta.pageNum * res.pageMeta.pageSize > res.pageMeta.total) {
                            this.setState({
                                hasMore: false,
                            });
                        }
                        let _items = this.state.data || [];
                        this.setState({
                            data: _items.concat(res.items),
                            pageNum: res.pageMeta.pageNum,
                            total: res.pageMeta.total,
                            loading: false,
                        });
                    }
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.AuthRecordDetail.tsx